import React from 'react';

export interface Props {
    width?: number;
    height?: number;
    style?: React.CSSProperties;
}

function PlaceHolderImage({ width = 250, height = 250, style = {} }: Props) {
    return (
        <svg
            x="0px"
            y="0px"
            viewBox="0 0 1024 1024"
            width={width}
            height={height}
            style={style}
            data-testid="placeholder"
        >
            <path
                fill="currentColor"
                d="M0.1,66.4c-1.5-21.3,14.5-47.5,32.6-47.1C50.9,19.7,358.1-0.9,379.5,0s37.5,14.1,39.1,38.6
		c1.6,24.4,22.5,312.1,20.2,339.9c-2.2,27.8-19.3,35.1-47,35.5c-27.7,0.3-285.4,22.4-320.6,24.8c-35.2,2.5-48.6-25.9-49-42
		C21.8,380.6,1.6,87.7,0.1,66.4L0.1,66.4z M794.3,329.6c-124.8,9.2-215.8,61.1-209,228.9S684.1,780,815.1,780s216.1-62,208.4-214.9
		C1015.9,412.2,919.1,320.5,794.3,329.6L794.3,329.6z M283.4,585c-17.1,0-22.9,2.8-34.3,22.9C237.7,628,74.7,949.1,68.9,966.4
		s-20.2,45.5,14.2,42.6s409.5,15,432.4,15c22.9,0,45.8-17,25.8-39.8C521.4,961.4,300.5,585,283.4,585L283.4,585z"
            />
        </svg>
    );
}

export default PlaceHolderImage;
